/** Single source for colors and type so scenes never hardcode hex values. */
export const COLORS = {
  background: 0x1b1530,
  surface: 0x2a2145,
  surfaceRaised: 0x3a2f5c,
  accent: 0xffb703,
  accentText: "#ffb703",
  positive: 0x5ee0a0,
  danger: 0xff5d73,
  text: "#f6f2ff",
  textMuted: "#b7aed1",
  ringIdle: 0x5a4d85,
  ringSelected: 0xffb703,
  ringVoted: 0x5ee0a0,
} as const;

export const FONT = {
  family: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
  title: 40,
  prompt: 30,
  body: 20,
  small: 16,
} as const;

export const SPACE = {
  xs: 6,
  sm: 12,
  md: 20,
  lg: 32,
} as const;
